import { useState } from "react";
import { toast } from "sonner";
import { Loader2 } from "lucide-react";
import { useAuth } from "../../../lib/auth";
import { api, formatError } from "../../../lib/api";
import { Group, Field } from "./shared";

export const AccountSection = () => {
  const { user, setUser } = useAuth();
  const [f, setF] = useState({ email: user.email || "", phone: user.phone || "", new_password: "", confirm: "", current_password: "" });
  const [busy, setBusy] = useState(false);
  const s = (k) => (v) => setF({ ...f, [k]: v });
  const submit = async () => {
    if (f.new_password && f.new_password !== f.confirm) return toast.error("New passwords do not match.");
    setBusy(true);
    try {
      const { data } = await api.put("/admin/account", { current_password: f.current_password, email: f.email || null, phone: f.phone || null, new_password: f.new_password || null });
      setUser(data); setF({ ...f, new_password: "", confirm: "", current_password: "" }); toast.success("Admin account updated.");
    } catch (e) { toast.error(formatError(e)); }
    finally { setBusy(false); }
  };
  return (
    <div className="space-y-6">
      <Group title="Admin sign-in details" desc="Change the email, phone number and password you use to sign in as admin.">
        <div className="grid gap-4 md:grid-cols-2">
          <Field label="Admin email" type="email" value={f.email} onChange={s("email")} testId="account-email-input" />
          <Field label="Admin phone (with country code, e.g. +2519...)" value={f.phone} onChange={s("phone")} testId="account-phone-input" />
          <Field label="New password (leave empty to keep current)" type="password" value={f.new_password} onChange={s("new_password")} testId="account-new-password-input" />
          <Field label="Confirm new password" type="password" value={f.confirm} onChange={s("confirm")} testId="account-confirm-password-input" />
        </div>
      </Group>
      <Group title="Confirm with your current password">
        <Field label="Current password" type="password" value={f.current_password} onChange={s("current_password")} testId="account-current-password-input" />
        <button type="button" onClick={submit} disabled={busy || !f.current_password} className="btn-gold" data-testid="account-save-btn">{busy && <Loader2 className="h-4 w-4 animate-spin" />}Update admin account</button>
      </Group>
    </div>
  );
};
